import { Component, inject, OnInit } from '@angular/core';
import { ApiService, QueryParam } from 'src/app/services/api.services';
import { AnalyticsTrackingService } from 'src/app/services/analytics-tracking.service';
import { CompanyEntityRelationshipTableComponent } from '../../../../components/company-entity-relationship-table/company-entity-relationship-table.component';

@Component({
	selector: 'app-my-list',
	templateUrl: './my-list.component.html',
	styleUrls: ['./my-list.component.css'],
	imports: [CompanyEntityRelationshipTableComponent],
})
export class MyListComponent implements OnInit {
	readonly dataRequest = (queryParams: QueryParam[]) =>
		this.apiService.getCompanyRelationships(queryParams);

	private readonly analytics = inject(AnalyticsTrackingService);

	constructor(private apiService: ApiService) {}

	ngOnInit(): void {
		this.analytics.logEvent('screen_view', {
			firebase_screen: 'MyCompaniesList',
			firebase_screen_class: 'MyListComponent',
		});
	}
}
